/**
 * rowQualityMark (#2773 C) — the visual marker for a row the default filter
 * hid, deliberately built the way ``estimateMark`` was: ONE module, so a chip
 * cannot grow a second wording, a second colour or a second pill per surface.
 *
 * The promise it renders: an ``untrustworthy`` row is hidden by default, and
 * the moment the reader reveals it, the row says WHY it was hidden — right
 * there in the Kultur column, not three clicks away in a drawer. Without this,
 * "hide behind a labelled filter" degrades into "hide".
 */
import { chipsFor, type ReasonGrain } from './rowQualityCopy';
import type { RowQuality } from './rowQuality';
import './rowQualityMark.css';

/**
 * The reason chips for one row or group. Renders nothing for an ``ok`` row — the
 * chip explains why a row was HIDDEN, so putting one on a row that is in the
 * overview (and counted in no hidden class) would contradict the subline. Safe to
 * mount unconditionally on every row.
 *
 * ``grain`` picks the explanation, not the word: a ``some()``-propagated reason
 * on a Kultur group says "mindestens ein Schlag …" (#2809), because the group
 * flag does not claim every member.
 */
export function RowQualityChips({ quality, grain }: { quality: RowQuality; grain: ReasonGrain }) {
  const chips = chipsFor(quality, grain);
  if (chips.length === 0) return null;
  return (
    <>
      {chips.map((chip) => (
        <span key={chip.reason} className="deckungsbeitrag-quality-chip" title={chip.title}>
          {chip.label}
        </span>
      ))}
    </>
  );
}
